import { Link as MuiLink } from '@mui/material'
import { SvgIconProps as IMuiSvgIconProps } from '@mui/material/SvgIcon';
import { Link } from 'react-router';

/*
*   Хлебные крошки: стил итема (одна ссылка в хлебных крошках)
*/

type IBreadcrumbItem = {
    label?: string,
    customRenderLabel?: any,
    link: string,
    icon?: IMuiSvgIconProps,
    isDisableLink?: boolean | undefined,
}


export function BreadcrumbItem({
    label = undefined,
    customRenderLabel = undefined,
    link,
    icon,
    isDisableLink = false,
}: IBreadcrumbItem) {

    return (
        <MuiLink
            noWrap
            sx={{
                display: 'flex',
                alignItems: 'center',
                lineHeight: 1.1,
                color: 'inherit',
                textDecoration: 'none',
                ...((isDisableLink === false || isDisableLink === undefined) && { cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }),
                ...((isDisableLink === true) && { pointerEvents: 'none', cursor: 'default', '&:hover': { textDecoration: 'none' } }),
            }}
            to={link}
            component={Link}
        >
            {icon} {customRenderLabel !== undefined
                ? customRenderLabel
                : label ? label : undefined
            }
        </MuiLink >
    );
}
